// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

type Classes = Pick<MuiButtonProps, 'classes'>;

export interface ButtonProps extends Omit<MuiButtonProps, 'classes'>, Partial<Classes> {
  className?: string;
  classes?: Record<string, any>;
  text?: React.ReactNode;
  loading?: boolean;
  error?: boolean;
  component?: React.ComponentType<any>;
  componentProps?: any;
  children?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const { text, loading, error, children, component: Component, componentProps, ...otherProps } = props;
  const baseProps: MuiButtonProps = {
    variant: 'contained',
    size: 'large',
    disabled: loading,
    color: 'primary',
    style: error ? { backgroundColor: '#DC5A3F', color: 'white' } : {}, // TODO move this logic to classes
    ...otherProps,
  };

  const spinner = loading ? <CircularProgress size={15} style={{ marginLeft: 8 }} /> : null;
  const classes = withStyles.getClasses(props);

  const content = (
    <MuiButton {...baseProps}>
      {text || children} {spinner}
    </MuiButton>
  );

  if (Component) {
    return (
      <Component {...componentProps}>
        {content}
      </Component>
    );
  }

  return content;
};

const ButtonStyled = withStyles(
  Button, 
  (theme, props) => ({
    "root": {
      whiteSpace: 'nowrap'
    }
  })
);

export default ButtonStyled;